"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const antd_1 = require("complex-component/antd");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const SelectModal_vue_1 = __importDefault(require("@/components/data/SelectModal.vue"));
const AssignList_vue_1 = __importDefault(require("@/pages/index/components/module/AssignList.vue"));
const plugin_1 = require("@/plugin");
const complex_1 = require("@/config/utils/complex");
const select_1 = require("@/pages/index/select");
const mainData_1 = __importDefault(require("./mainData"));
const preservationFlowConfig_1 = require("../../external/preservation/preservationFlowConfig");
const role_1 = __importStar(require("@/pages/index/data/role"));
const redeemFlowConfig_1 = require("../../handle/redeem/redeemFlowConfig");
const disposeFlowConfig_1 = require("../../handle/dispose/disposeFlowConfig");
const BuildMessage_vue_1 = __importDefault(require("./components/BuildMessage.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'OverdueList',
    components: {
        ListView: ListView_1.default,
        SelectModal: SelectModal_vue_1.default,
        ComplexAutoModal: antd_1.ComplexAutoModal,
        AssignList: AssignList_vue_1.default,
        BuildMessage: BuildMessage_vue_1.default
    },
    data() {
        return {
            localLife: {},
            mainData: mainData_1.default,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {},
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    },
                    {
                        prop: 'phone',
                        name: '电催人员分派',
                        type: 'primary',
                        disabled: () => {
                            return mainData_1.default.$module.choice.getId().length === 0;
                        }
                    },
                    {
                        prop: 'visit',
                        name: '上门人员分派',
                        type: 'primary',
                        disabled() {
                            return mainData_1.default.$module.choice.getId().length === 0;
                        }
                    },
                    {
                        prop: 'assignLog',
                        name: '分派记录',
                        type: 'primary',
                        disabled() {
                            return mainData_1.default.$module.choice.getId().length !== 1;
                        }
                    },
                    {
                        prop: 'message',
                        name: '短信通知',
                        type: 'primary',
                        disabled() {
                            return mainData_1.default.$module.choice.getId().length !== 1;
                        }
                    },
                    {
                        prop: 'export',
                        name: '导出',
                        type: 'primary'
                    }
                ],
                menu: {
                    list: [
                        {
                            prop: 'preservation',
                            name: '保全',
                            hidden({ record }) {
                                // 逾期状态 = 逾期 && 车辆状态 = 正常
                                if (record.overStatus.value === '2' && record.vehicleStatus.value === '1' && (0, role_1.hasRole)(role_1.default.preservation.build)) {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        },
                        {
                            prop: 'redeem',
                            name: '赎回',
                            hidden({ record }) {
                                // 逾期状态 = 逾期 && 车辆状态 = 已收车
                                if (record.overStatus.value === '2' && record.vehicleStatus.value === '2' && (0, role_1.hasRole)(role_1.default.redeem.build)) {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        },
                        {
                            prop: 'dispose',
                            name: '处置',
                            hidden({ record }) {
                                // 逾期状态 = 逾期 && 车辆状态 = 已收车
                                if (record.overStatus.value === '2' && record.vehicleStatus.value === '2' && (0, role_1.hasRole)(role_1.default.dispose.build)) {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        },
                        {
                            prop: 'guarantor',
                            name: '追加担保人',
                            hidden({ record }) {
                                // 逾期状态 = 逾期 || 逾期状态 = 赎回中
                                if ((record.overStatus.value === '2' || record.overStatus.value === '11') && (0, role_1.hasRole)(role_1.default.guarantor.build)) {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        },
                    ]
                }
            },
            modal: {
                assign: ''
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        },
        choice() {
            return this.mainData.$module.choice.getData();
        }
    },
    mounted() {
        let search = this.$route.query.search;
        if (search) {
            search = JSON.parse(search);
            this.mainData.$setSearchForm(search, {
                force: true
            });
        }
        this.mainData.$loadData(true);
        (0, complex_1.bindLifeOnPage)(this.mainData, this, 'menu', (type, record) => {
            this.$router.push(`/overdue/info/${record.id}`);
        });
    },
    beforeUnmount() {
        (0, complex_1.unbindLifeOnPage)(this.mainData, this, 'menu');
    },
    methods: {
        onSend() {
            this.mainData.$module.choice.$reset();
        },
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onMenu(from, act, payload) {
            if (from === 'search') {
                if (act === 'phone') {
                    this.$refs['select-modal'].show('电催人员分派', select_1.operationPersonnel, (val) => {
                        this.mainData.$triggerMethod('assignItem', [this.choice.list, val.value, 1], true);
                    }, {
                        line: 2
                    });
                }
                else if (act === 'visit') {
                    this.$refs['select-modal'].show('上门人员分派', select_1.operationPersonnel, (val) => {
                        this.mainData.$triggerMethod('assignItem', [this.choice.list, val.value, 2], true);
                    }, {
                        line: 2
                    });
                }
                else if (act === 'assignLog') {
                    this.modal.assign = this.choice.id[0];
                    this.$refs.assign.show('分派历史记录');
                }
                else if (act === 'message') {
                    this.$refs.message.onBuild(this.choice.list[0]);
                }
            }
            else if (from === 'table') {
                if (act === 'preservation') {
                    (0, preservationFlowConfig_1.toPreservationInfo)('build', payload.record.id, 'start');
                }
                else if (act === 'redeem') {
                    (0, redeemFlowConfig_1.toRedeemInfo)('build', payload.record.id, 'start');
                }
                else if (act === 'dispose') {
                    (0, disposeFlowConfig_1.toDisposeInfo)('build', payload.record.id, 'start');
                }
                else if (act === 'guarantor') {
                    this.$router.push(`/overdue/guarantor/info/${payload.record.id}/build`);
                }
            }
        }
    }
});
